import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let messagingInstance = null;

const getMessagingInstance = () => {
  if (!messagingInstance) {
    const app = initializeApp(firebaseConfig);
    messagingInstance = getMessaging(app);
  }
  return messagingInstance;
};

export const getFcmToken = async (): Promise<string | null> => {
  try {
    const messaging = getMessagingInstance();
    const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY;
    if (!vapidKey) {
      console.warn("VITE_FIREBASE_VAPID_KEY is not set");
      return null;
    }
    const currentToken = await getToken(messaging, { vapidKey });
    return currentToken || null;
  } catch (error) {
    console.error("FCM getToken failed", error);
    return null;
  }
};

export const onForegroundMessage = (callback: (payload: any) => void) => {
  try {
    const messaging = getMessagingInstance();
    const unsubscribe = onMessage(messaging, (payload) => {
      callback(payload);
    });
    return unsubscribe;
  } catch (error) {
    console.error("FCM onMessage failed", error);
    return () => {};
  }
};

export const getBase64FromFBUrl = async (firebaseUrl: string): Promise<string | null> => {
  if (!firebaseUrl) return null;

  try {
    const response = await fetch(firebaseUrl);
    if (!response.ok) return null;

    const blob = await response.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
};
